import { toastConstants } from '../constants';
const { ENQUEUE_TOAST } = toastConstants;

export function toast(toastObject) {
    return dispatch => {
        return dispatch({
            type: ENQUEUE_TOAST,
            toast: toastObject,
        });
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/toast.actions.js